module.exports = __webpack_public_path__ + "img/Picture 2.cf93dc33.png";